// Define the base URL based on the environment
const BASE_URL = process.env.NODE_ENV === "development" 
  ? "http://localhost:5000/v1/fuso-ascent-pnc-search/"
  : "/v1/fuso-ascent-pnc-search/";

// Define shop manual base URL
const SHOP_MANUAL_BASE_URL = process.env.NODE_ENV === "development" 
  ? "http://localhost:5000/api/v1/shop-manual/"
  : "/api/v1/shop-manual/";

// Define all API endpoints in a centralized object
export const CHAT_API_ENDPOINTS = {
  // User management endpoint
  CREATE_USER: `${BASE_URL}user_details`,
  
  // Catalog and search related endpoints
  GET_CATALOG: `${BASE_URL}get-catalog`,
  // GET_SUB_GROUP: `${BASE_URL}get-sub-group`,
  GET_VIN_SUGGESTIONS: `${BASE_URL}get-vin-suggestions`,
  FINAL_QUERY: `${BASE_URL}final-query-route`,
  
  // Chat history related endpoints
  GET_CHAT_HISTORY_LIST: `${BASE_URL}title_list`,
  GET_CHAT_HISTORY_DETAILS: `${BASE_URL}chat_history`,
  DELETE_CHAT_HISTORY: `${BASE_URL}clear_chat`,
  
  // Chat management endpoints
  PIN_CHAT: `${BASE_URL}pin_chat`,
  FEEDBACK_PARTICULAR: `${BASE_URL}feedback_particular_chat`,
  ADD_FEEDBACK: `${BASE_URL}add_feedback`,
  
  // Shop manual endpoints
  SHOP_MANUAL_CHAT: `${SHOP_MANUAL_BASE_URL}chat`,

  // Shop manual Chat history related endpoints
  SHOP_MANUAL_GET_CHAT_HISTORY_LIST: `${SHOP_MANUAL_BASE_URL}title_list`,
  SHOP_MANUAL_GET_CHAT_HISTORY_DETAILS: `${SHOP_MANUAL_BASE_URL}chat_history`,
  SHOP_MANUAL_DELETE_CHAT_HISTORY: `${SHOP_MANUAL_BASE_URL}clear_chat`,

   // Shop Manual Chat management endpoints
  SHOP_MANUAL_PIN_CHAT: `${SHOP_MANUAL_BASE_URL}pin_chat`,
  SHOP_MANUAL_FEEDBACK_PARTICULAR: `${SHOP_MANUAL_BASE_URL}feedback_particular_chat`,
  SHOP_MANUAL_ADD_FEEDBACK: `${SHOP_MANUAL_BASE_URL}add_feedback`,
  SHOP_MANUAL_VIN_SEARCH: `${SHOP_MANUAL_BASE_URL}fetch_vin_list`,
  SHOP_MANUAL_PUBLICATION_SEARCH: `${SHOP_MANUAL_BASE_URL}fetch_pub_number_list`,
  SHOP_MANUAL_MODEL_DETAILS: `${SHOP_MANUAL_BASE_URL}fetch_model_details`,
  SHOP_MANUAL_MODEL_SUGGESTION: `${SHOP_MANUAL_BASE_URL}fetch_model_suggestion`,
  SHOP_MANUAL_CLASSIFICATION_SUGGESTION: `${SHOP_MANUAL_BASE_URL}fetch_classification_suggestion`,
  SHOP_MANUAL_VEHICLE_TYPES: `${SHOP_MANUAL_BASE_URL}fetch_vehicle_types`
};

export default CHAT_API_ENDPOINTS;